import store from '../../main';
import calendarHelpers from '../../../views/calendarView/helpers';

export const initAdapter = (calendarInstance, ganttInstance, projectId) => {
  const calendarState = calendarInstance.api.getReactiveState();

  store.subscribe((mutation, state) => {
    if (mutation.payload?.fromCalendar || !calendarInstance.api) return;

    if (mutation.type === 'tasksModel/updateTask') {
      const isEventExist = calendarInstance.getEvent({ id: mutation.payload.id });
      const isTask = mutation.payload.type === 'task';
      const isMilestone = mutation.payload.type === 'milestone';
      const isCorrectProjectId = mutation.payload.gantt_id === projectId;

      if ((isTask || isMilestone) && isEventExist) {
        if (!calendarHelpers.hasAccessToTask(mutation.payload)) {
          calendarInstance.api.exec('delete-event', { id: mutation.payload.id, fromStore: true });

          return;
        }

        if (isMilestone) {
          calendarInstance.api.exec('delete-event', { id: mutation.payload.id, fromStore: true });

          return;
        }

        const tasks = store.getters['tasksModel/getTasksForGantt'](mutation.payload.gantt_id).data;

        calendarInstance.api.exec('update-events', {
          projectId: mutation.payload.gantt_id,
          tasks,
        });
      }

      if (!isEventExist && isCorrectProjectId && isTask && calendarHelpers.hasAccessToTask(mutation.payload)) {
        const calendarEventByTask = calendarHelpers.prepareEvent(mutation.payload);
        const task = mutation.payload;

        if (task.task_created_from_calendar && task.resources.length) {
          const parentData = gantt.getTaskByIndex(0);
          const assignedResources = task.resources.map(resource => ({
            id: resource.id,
            userId: resource.userId,
            action: 'insert',
            value: 8,
          }));

          store.dispatch('tasksModel/changeAssign', {
            changedResources: assignedResources,
            isTaskCreation: true,
            taskId: task.id,
            ganttId: parentData.gantt_id,
          });
        } else {
          calendarInstance.api.exec('add-event', { event: calendarEventByTask, taskData: mutation.payload, fromStore: true });
        }
      }
    }

    if (mutation.type === 'tasksModel/updateTaskResourcesByGanttId') {
      const tasks = store.getters['tasksModel/getTasksForGantt'](mutation.payload.ganttId).data;

      calendarInstance.api.exec('update-events', {
        projectId: mutation.payload.ganttId,
        tasks,
      });

      return;
    }

    if (mutation.type.includes('tasksModel/updateProjectTasksData')) {
      calendarInstance.api.exec('update-events', {
        projectId: mutation.payload.id,
        tasks: mutation.payload.tasks,
      });
    }

    if (mutation.type.includes('tasksModel/addTask')) {
      const isEventExist = calendarInstance.getEvent({ id: mutation.payload.id });

      if (!isEventExist && calendarHelpers.hasAccessToTask(mutation.payload)) {
        const calendarEventByTask = calendarHelpers.prepareEvent(mutation.payload);
        const task = mutation.payload;

        if (task.task_created_from_calendar && task.resources.length) {
          const parentData = gantt.getTaskByIndex(0);
          const assignedResources = task.resources.map(resource => ({
            id: resource.id,
            userId: resource.userId,
            action: 'insert',
            value: 8,
          }));

          store.dispatch('tasksModel/changeAssign', {
            changedResources: assignedResources,
            isTaskCreation: true,
            taskId: task.id,
            ganttId: parentData.gantt_id,
          });
        } else {
          calendarInstance.api.exec('add-event', { event: calendarEventByTask, taskData: mutation.payload, fromStore: true });
        }
      }
    }

    if (mutation.type.includes('tasksModel/deleteTask')) {
      const isEventExist = calendarInstance.getEvent({ id: mutation.payload.id });

      if (isEventExist) {
        calendarInstance.api.exec('delete-event', { id: mutation.payload.id, fromStore: true });

        const parentsTasks = store.getters['tasksModel/getParentTasksByGanttId'](mutation.payload.gantt_id);

        parentsTasks.forEach(taskData => {
          const childTasks = store.getters['tasksModel/getChildByTask'](mutation.payload.gantt_id, taskData.id);

          if (!childTasks.length && taskData.parent !== 0) {
            taskData.type === 'task';

            const calendarEventByTask = calendarHelpers.prepareEvent(taskData);

            calendarInstance.api.exec('add-event', { event: calendarEventByTask, taskData, fromStore: true });
          }
        });
      }
    }

    if (mutation.type.includes('headerView/setCalendarStep')) {
      calendarInstance.api.exec('set-bound', { step: mutation.payload });
    }

    if (mutation.type.includes('headerView/setCalendarTodayDate')) {
      calendarInstance.api.exec('set-date', { value: mutation.payload });
    }
  });

  calendarState.date.subscribe(date => {
    store.commit('headerView/setCalendarViewDate', { date, fromCalendar: true });
  });

  calendarInstance.api.on('update-task-by-worker', task => {
    ganttInstance.ganttWorker.calculate([task], 'changeTasks', 'updateTasks');
  });

  calendarInstance.api.on('create-task-from-calendar', data => {
    const { task, parentId, sortOrderAndIndex } = data;

    ganttInstance.createTask(webix.copy(task), parentId, sortOrderAndIndex);
  });
};

export default {
  initAdapter,
};
